// Movies
export const SELECT_MOVIE = 'SELECT_MOVIE';
export const QUERY_MOVIES = 'QUERY_MOVIES';
export const RECEIVE_MOVIES_QUERY = 'RECEIVE_MOVIES_QUERY';
export const DISCOVER_MOVIES = 'DISCOVER_MOVIES';
export const MOVIE_DETAIL = 'MOVIE_DETAIL';
export const MOVIE_GENRES = 'MOVIE_GENRES';
export const GET_MOVIE_REQUEST = 'GET_MOVIE_REQUEST';
export const MOVIE_RECOMMENDATIONS = 'MOVIE_RECOMMENDATIONS';
export const MOVIES_CASTS = 'MOVIES_CASTS';
export const GET_IMDB_INFO = 'GET_IMDB_INFO';
export const MOVIE_REVIEWS = 'MOVIE_REVIEWS';
export const TRENDING_MOVIES = 'TRENDING_MOVIES';
export const NOW_PLAYING_MOVIES = 'NOW_PLAYING_MOVIES';
export const POPULAR_MOVIES = 'POPULAR_MOVIES';
export const TOP_RATED_MOVIES = 'TOP_RATED_MOVIES';
export const UPCOMING_MOVIES = 'UPCOMING_MOVIES';

// WEATHER
export const FETCH_LOCATION = 'FETCH_LOCATION';
export const GEOPOSITION_SEARCH = 'GEOPOSITION_SEARCH';
export const GET_LOCATION_KEY = 'GET_LOCATION_KEY';
export const GET_TEMPERATURE = 'GET_TEMPERATURE';

// LOGIN
export const LOGIN_STATE = 'LOGIN_STATE';
export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGOUT = 'USER_LOGOUT';
export const FACEBOOK_LOGIN = 'FACEBOOK_LOGIN';
export const TWITTER_LOGIN = 'TWITTER_LOGIN';
export const GOOGLE_LOGIN = 'GOOGLE_LOGIN';

// RESTAURANTS
export const FETCH_RESTAURANTS = 'FETCH_RESTAURANTS';
export const RECEIVE_RESTAURANTS = 'RECEIVE_RESTAURANTS';
export const RECEIVE_SEARCHED_RESTAURANTS = 'RECEIVE_SEARCHED_RESTAURANTS';
export const RECEIVE_RESTAURANTS_DETAILS = 'RECEIVE_RESTAURANTS_DETAILS';
export const RECEIVE_RESTAURANTS_REVIEWS = 'RECEIVE_RESTAURANTS_REVIEWS';

// FAVORITE
export const ADD_FAVORITE = 'ADD_FAVORITE';
export const REMOVE_FAVORITE = 'REMOVE_FAVORITE';
export const TOGGLE_FAVORITE = 'TOGGLE_FAVORITE';
export const GET_FAVORITES = 'GET_FAVORITES';
export const REQUIRE_FAVORITE_STATE = 'REQUIRE_FAVORITE_STATE';
